import {http} from '@/http/index.js';

async function loadCover(data) {
  return http.post('/girl/cover', data).then((response) => response.data.data);
}

export {loadCover};
